import { useState, useEffect } from "react";

/**
 * Try to load an image, fallback safely if it fails.
 *
 * @param {String} desiredImageUrl - the image url you want to load.
 * @param {String} fallbackUrl - the image url to load if there's a problem.
 *
 * @return {String} - a successfully loaded image URL.
 */

function useImageLoader(desiredImageUrl, fallbackUrl = null) {
	const [url, setImageUrl] = useState(null);

	useEffect(() => {
		const img = new Image();
		img.onload = () => setImageUrl(desiredImageUrl);
		img.onerror = () => setImageUrl(fallbackUrl);
		img.src = desiredImageUrl;
	}, [desiredImageUrl, fallbackUrl]);

	return url;
}

export default useImageLoader;



// WEBPACK FOOTER //
// ./src/shared/hooks/useImageLoader.js